export default class MediaQueryHandler {
	/**
	 * Creates an instance of the MediaQueryHandler class
	 * @param {string} customMediaQuery - String with custom media query
	 * @param {Function} callback - Callback function called when the state of the media query changes
	 */
	constructor(customMediaQuery, callback) {
		this.mediaQuery = window.matchMedia(customMediaQuery)
		this.handlerMQChange = this.handlerMQChange.bind(this)
		this.callback = callback

		this.init()
	}

	/**
	 * Initializes listening for media query state changes
	 */
	init() {
		this.handlerMQChange(this.mediaQuery)
		this.mediaQuery.addEventListener('change', this.handlerMQChange)
	}

	/**
	 * Media Query State Change Handler
	 * @param {MediaQueryListEvent} e - Media Query State Change Event Object
	 */
	handlerMQChange(e) {
		if (this.callback && typeof this.callback === 'function') {
			this.callback(e.matches)
		}
	}

	/**
	 * Stops listening for media query state changes
	 * Just call outside mediaQueryHandler.destroy()
	 */
	destroy() {
		this.mediaQuery.removeEventListener('change', this.handlerMQChange)
	}
}


// * Example of using a class
/**
 * Callback function called when the state of the media query changes
 * @param {boolean} matches - Media query match result
 * function handlerTabletChange(matches) {
 * 	if (matches) {
 * 		console.log('true')
 * 	} else {
 * 		console.log('false')
 * 	}
 * }
 *
 * const mediaQueryHandler = new MediaQueryHandler('screen and (max-width: 768px)', handlerTabletChange)
 *
 */
